import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ConditionalWrapper from './ConditionalWrapper'
import DropChildrenMotion from './DropChildrenMotion'
import Item, { AnchorItem } from './Item'
import ItemImage from './ItemImage'
import ItemAC from './items/AC'
import ItemBlinds from './items/Blinds'
import ItemEntertainmentSystem from './items/EntertainmentSystem'
import ItemPlant from './items/Plant'
import ItemPowerStrip from './items/PowerStrip'
import ItemRug from './items/Rug'
import ItemChloe from './items/Chloe'
import ItemSofa1 from './items/Sofa1'
import ItemSofa2 from './items/Sofa2'
import WallsGreenImage from '../assets/images/walls--green@3x.png'
import FloorWoodImage from '../assets/images/floor--wood@3x.png'

const Container = styled.div`
  position: relative;
  pointer-events: none;
`

export default class RoomLiving extends Component {
  static propTypes = {
    dropChildrenMotion: PropTypes.bool,
    onItemClick: PropTypes.func,
    pendingHighlightIds: PropTypes.arrayOf(PropTypes.string),
    successHighlightIds: PropTypes.arrayOf(PropTypes.string),
  }

  static defaultProps = {
    dropChildrenMotion: true,
    onItemClick: (id) => console.log(`clicked ${id}`),
    pendingHighlightIds: [],
    successHighlightIds: [],
  }

  static items = [
    {
      id: 'blinds',
      component: ItemBlinds,
      left: 57.25,
      bottom: 29.5,
      width: 33,
    },
    {
      id: 'plant',
      component: ItemPlant,
      left: 42,
      bottom: 43,
      width: 21,
    },
    {
      id: 'entertainmentSystem',
      component: ItemEntertainmentSystem,
      left: 10,
      bottom: 25.2,
      width: 40,
    },
    {
      id: 'powerStrip',
      component: ItemPowerStrip,
      left: 4.7,
      bottom: 23.65,
      width: 12.5,
    },
    {
      id: 'rug',
      component: ItemRug,
      left: 21,
      bottom: 5,
      width: 70,
    },
    {
      id: 'sofa1',
      component: ItemSofa1,
      left: 39.5,
      bottom: 17.18,
      width: 47.4,
    },
    {
      id: 'chloe',
      component: ItemChloe,
      left: 65.3,
      bottom: 32.15,
      width: 9.5,
      animate: true,
    },
    {
      id: 'sofa2',
      component: ItemSofa2,
      left: 35.9,
      bottom: 7.67,
      width: 51.1,
    },
    {
      id: 'ac',
      component: ItemAC,
      left: 20.97,
      bottom: 60.11,
      width: 31,
      animate: true,
    },
  ]

  shouldAnimate(id) {
    const { animateIds } = this.props

    return animateIds.includes(id)
  }

  shouldShowHighlight(id) {
    const { pendingHighlightIds: pending, successHighlightIds: success } =
      this.props

    return pending.includes(id) || success.includes(id)
  }

  getHighlightType(id) {
    const { pendingHighlightIds: pending, successHighlightIds: success } =
      this.props

    if (pending.includes(id)) return 'pending'
    if (success.includes(id)) return 'success'

    return null
  }

  renderItem(item) {
    const { onItemClick } = this.props
    const { id, component: Comp, left, bottom, width, animate = false } = item

    const isEntertainmentSystem = id === 'entertainmentSystem'
    const hasBeenClickedBefore = !this.props.pendingHighlightIds.includes(id)
    const shouldShowEasterEgg = isEntertainmentSystem && hasBeenClickedBefore

    const ItemComponent = shouldShowEasterEgg ? AnchorItem : Item

    return (
      <ItemComponent
        left={left}
        bottom={bottom}
        width={width}
        key={'RoomLiving__Item--' + id}
        href={shouldShowEasterEgg ? 'https://youtu.be/6DL37kDE01Q' : undefined}
        target={shouldShowEasterEgg ? '_blank' : undefined}
      >
        <Comp
          animate={this.shouldAnimate(id) || animate}
          highlight={this.shouldShowHighlight(id)}
          highlightType={this.getHighlightType(id)}
          onClick={() => onItemClick(id)}
        />
      </ItemComponent>
    )
  }

  render() {
    const { children, dropChildrenMotion, onItemClick, ...props } = this.props

    return (
      <Container {...props}>
        <ItemImage src={WallsGreenImage} />
        <Item left={-3.4} bottom={-0.5} width={101.65}>
          <ItemImage src={FloorWoodImage} />
        </Item>
        <ConditionalWrapper
          condition={dropChildrenMotion}
          wrapper={DropChildrenMotion}
        >
          {RoomLiving.items.map(this.renderItem.bind(this))}
          {children}
        </ConditionalWrapper>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/RoomLiving.js